import { type IApp } from 'src/graphql/schema';
import { AppAvatar } from 'src/widgets/AppCard';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

type Props = {
  app: Pick<IApp, 'id' | 'name' | 'logoUrl' | 'ownerName' | 'ownerWebsite'>;
};

const DepositorReadOnlyCard = ({ app }: Props) => {
  const name = app.name ?? 'Untitled Application';

  const rows = [
    { id: 'vendor', label: 'Vendor', value: app.ownerName },
    { id: 'website', label: 'Website', value: app.ownerWebsite || '-' },
  ];

  return (
    <Card>
      <CardHeader className="flex-row items-center gap-3 space-y-0 pb-4">
        <AppAvatar
          appId={app.id}
          name={name}
          claimed
          shape="rounded-square"
          size="md"
          logoUrl={app.logoUrl ?? undefined}
        />
        <CardTitle className="text-sm">{name}</CardTitle>
      </CardHeader>
      <CardContent>
        <Table className="border-y border-border">
          <TableBody>
            {rows.map(({ id, label, value }) => (
              <TableRow key={id} className="hover:bg-white">
                <TableCell className="pl-0 py-3 w-50 font-semibold text-slate-700">{label}</TableCell>
                <TableCell className="py-3 px-0 w-4">:</TableCell>
                <TableCell className="py-3 text-foreground">{value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default DepositorReadOnlyCard;
